import { platformSystemNotificationActionPathSchema } from '@crest/platform-contracts';
import { z } from 'zod';
export const communicationsTimesheetsLunchCorrectionRequestedEventName = 'timesheets.lunch-correction-requested.v2';
export const communicationsTimesheetsMissingLunchReportReadyEventName = 'timesheets.missing-lunch-report-ready.v2';
export const communicationsTimesheetsActionableReviewSubscriberId = 'communications.subscribers.timesheets-actionable-review';
export const communicationsTimesheetsActionableSystemNotificationSourceEventVersion = 2;
export const communicationsTimesheetsActionableSystemNotificationKindSchema = z.enum([
    'timesheets-lunch-correction',
    'timesheets-missing-lunch-report',
]);
const canonicalUuidSchema = z.string().uuid().regex(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/);
const workDateSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/).refine((value) => {
    const year = Number(value.slice(0, 4));
    const month = Number(value.slice(5, 7));
    const day = Number(value.slice(8, 10));
    const leap = year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
    const daysInMonth = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return year >= 1 && month >= 1 && month <= 12
        && day >= 1 && day <= (daysInMonth[month - 1] ?? 0);
}, 'Expected a real YYYY-MM-DD calendar date.');
const timestampSchema = z.string().datetime({ offset: true });
export const communicationsTimesheetsLunchCorrectionPayloadSchema = z.strictObject({
    requestId: canonicalUuidSchema,
    membershipId: canonicalUuidSchema,
    workDate: workDateSchema,
});
export const communicationsTimesheetsMissingLunchReportPayloadSchema = z.strictObject({
    reportRunId: canonicalUuidSchema,
    workDate: workDateSchema,
});
const correctionActionPathSchema = z.string().regex(/^\/timesheets\/lunch-review\/date\/\d{4}-\d{2}-\d{2}\/member\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}\/request\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).pipe(platformSystemNotificationActionPathSchema);
const reportActionPathSchema = z.string().regex(/^\/timesheets\/lunch-review\/date\/\d{4}-\d{2}-\d{2}\/report\/[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/).pipe(platformSystemNotificationActionPathSchema);
export const communicationsTimesheetsLunchCorrectionSystemNotificationRowSchema = z.strictObject({
    intent_id: canonicalUuidSchema,
    source_event_id: canonicalUuidSchema,
    source_occurred_at: timestampSchema,
    recipient_membership_id: canonicalUuidSchema,
    subject_membership_id: canonicalUuidSchema,
    work_date: workDateSchema,
    action_path: correctionActionPathSchema,
});
export const communicationsTimesheetsMissingLunchReportSystemNotificationRowSchema = z.strictObject({
    intent_id: canonicalUuidSchema,
    source_event_id: canonicalUuidSchema,
    source_occurred_at: timestampSchema,
    recipient_membership_id: canonicalUuidSchema,
    work_date: workDateSchema,
    action_path: reportActionPathSchema,
});
export const communicationsTimesheetsActionableSystemNotificationPresentation = {
    'timesheets-lunch-correction': {
        sourceKind: 'timesheets-lunch-correction',
        title: 'Lunch correction needs review',
        body: 'A team member submitted a missing-lunch correction.',
    },
    'timesheets-missing-lunch-report': {
        sourceKind: 'timesheets-missing-lunch-report',
        title: 'Missing-lunch report ready',
        body: 'A missing-lunch report is ready for review.',
    },
};
export function composeCommunicationsTimesheetsLunchCorrectionActionPath(input) {
    const parsed = communicationsTimesheetsLunchCorrectionPayloadSchema.parse(input);
    return correctionActionPathSchema.parse(`/timesheets/lunch-review/date/${parsed.workDate}/member/${parsed.membershipId}/request/${parsed.requestId}`);
}
export function composeCommunicationsTimesheetsMissingLunchReportActionPath(input) {
    const parsed = communicationsTimesheetsMissingLunchReportPayloadSchema.parse(input);
    return reportActionPathSchema.parse(`/timesheets/lunch-review/date/${parsed.workDate}/report/${parsed.reportRunId}`);
}
//# sourceMappingURL=communications-timesheets-actionable-system-notification.contract.js.map